import { createConstructor } from './Dataset.js';
export default class DatasetFactory {
    dataset;
    init() {
        const Dataset = createConstructor(this);
        this.dataset = ((quads = []) => {
            return new Dataset([...quads]);
        });
        this.dataset.Class = Dataset;
    }
}
